export default __webpack_public_path__ + "static/media/2.d16f1281.webp";